import { Avatar, Box, List, ListItem, ListItemAvatar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LegendSectionTitle } from './LegendSectionTitle';
import { LegendListItemText } from './LegendListItemText';

export const FemaFloodHazardLegend = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <List
      disablePadding
      dense
      subheader={
        <LegendSectionTitle titleSx={{ lineHeight: 1.2, pt: 1 }}>
          {t('map.legends.femaFloodHazard.title')}
        </LegendSectionTitle>
      }
    >
      <ListItem alignItems="flex-start">
        <LegendListItemText
          variant="watchduty-legend"
          primary={t('map.legends.femaFloodHazard.subtitle')}
        />
      </ListItem>
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar variant="square">
            <Box
              sx={{
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(134, 92, 152, 1)',
                background: `url("/images/flood-hazard/floodway.svg")`,
                backgroundSize: 'cover',
              }}
            />
          </Avatar>
        </ListItemAvatar>
        <LegendListItemText
          variant="watchduty-legend"
          primary={t('map.legends.femaFloodHazard.legends.regulatory.title')}
          secondary={t(
            'map.legends.femaFloodHazard.legends.regulatory.subtitle',
          )}
        />
      </ListItem>
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar variant="square">
            <Box
              sx={{
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(134, 92, 152, 0.6)',
                backgroundImage: `url("/images/flood-hazard/100year.svg")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                border: '1.5px solid rgba(134, 92, 152, 0.75)',
              }}
            />
          </Avatar>
        </ListItemAvatar>
        <LegendListItemText
          variant="watchduty-legend"
          primary={t('map.legends.femaFloodHazard.legends.onePct.title')}
          secondary={t('map.legends.femaFloodHazard.legends.onePct.subtitle')}
        />
      </ListItem>
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar variant="square">
            <Box
              sx={{
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(134, 92, 152, 1)',
                background: `url("/images/flood-hazard/levee.svg")`,
                backgroundSize: 'cover',
              }}
            />
          </Avatar>
        </ListItemAvatar>
        <LegendListItemText
          variant="watchduty-legend"
          primary={t('map.legends.femaFloodHazard.legends.levee.title')}
          secondary={t('map.legends.femaFloodHazard.legends.levee.subtitle')}
        />
      </ListItem>
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar variant="square">
            <Box
              sx={{
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(134, 92, 152, 0.4)',
                backgroundImage: `url("/images/flood-hazard/500year.svg")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                border: '1.5px solid rgba(134, 92, 152, 0.75)',
              }}
            />
          </Avatar>
        </ListItemAvatar>
        <LegendListItemText
          variant="watchduty-legend"
          primary={t('map.legends.femaFloodHazard.legends.zeroTwoPct.title')}
          secondary={t(
            'map.legends.femaFloodHazard.legends.zeroTwoPct.subtitle',
          )}
        />
      </ListItem>
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <Avatar variant="square">
            <Box
              sx={{
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                background: `url("/images/flood-hazard/undetermined.svg")`,
                backgroundSize: 'cover',
              }}
            />
          </Avatar>
        </ListItemAvatar>
        <LegendListItemText
          variant="watchduty-legend"
          primary={t('map.legends.femaFloodHazard.legends.undetermined.title')}
          secondary={t(
            'map.legends.femaFloodHazard.legends.undetermined.subtitle',
          )}
        />
      </ListItem>
    </List>
  );
};
